import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getStudentObservationTableAction } from '../actions';

const {
  useLoaderData: StudentObservationFiltersLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getStudentObservationTableAction,
});

function StudentObservationFiltersLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentObservationFiltersLoader, StudentObservationFiltersLoaderData };
